import { LocalFireDepartment } from "@mui/icons-material";
import { Box, Button, Grid } from "@mui/material";
import Aos from "aos";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const galleryItems = [
  {
    image:
      "https://i.pinimg.com/originals/44/a7/db/44a7db3ea5b4d644696c6493f0b2a4fa.webp",
    title: "Build your online store!",
    description:
      "Build your online store with our easy to use platform. We have all the tools you need to get started.Our website has the best sales for 2024!",
    buttonText: "get started",
    link: "/Contacts",
  },
  {
    image:
      "https://i.pinimg.com/originals/15/b5/e1/15b5e16ed99ef468d5461f86eb0b0920.jpg",
    title: "Brand your product!",
    description:
      "Elevate your online presence with Sirius Team! Our expert web development services transform your vision into a captivating, functional, and user-friendly website, ensuring you stand out in the digital landscape.",
    buttonText: "get started",
    link: "/Contacts",
  },
];

function Smgallary() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={2}
      sx={{
        padding: "30px 6rem",
        placeContent:'center'
      }}
    >
      {galleryItems.map((item, index) => (
        <React.Fragment key={index}>
          {index % 2 === 0 ? (
            <>
              <Grid item xs={12} md={6}>
                <Box  
                data-aos="zoom-in-right"
                  sx={{
                    width: "100%",   

                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  <img
                    src={item.image}
                    alt="smallgallery"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4} data-aos="zoom-out-left">
                <Box
                  sx={{
                    maxWidth: "400px",
                    textAlign: { xs: "center", md: "left" },
                    mx: { xs: "auto", md: "0" },
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2rem",
                      fontWeight: "600",
                      marginBottom: "10px",
                      paddingRight: "20px",
                    }}
                  >
                    {item.title}
                  </h1>
                  <p style={{ opacity: 0.8, marginBottom: "15px" }}>
                    {item.description}
                  </p>
                  <Button
                    variant="contained"
                    onClick={() => navigate(item.link)}
                    endIcon={<LocalFireDepartment />}
                    style={{ color: "#FFf", backgroundColor: "#e84545" }}
                  >
                    {item.buttonText}
                  </Button>
                </Box>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} md={4} data-aos="zoom-out-right">
                <Box
                  sx={{
                    maxWidth: "400px",
                    textAlign: { xs: "center", md: "left" },
                    mx: { xs: "auto", md: "0" },
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2rem",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    {item.title}
                  </h1>
                  <p style={{ opacity: 0.8, marginBottom: "15px" }}>
                    {item.description}
                  </p>
                  <Button
                    variant="contained"
                    onClick={() => navigate(item.link)}
                    endIcon={<LocalFireDepartment />}
                    style={{ color: "#FFf", backgroundColor: "#e84545" }}
                  >
                    {item.buttonText}
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    textAlign: { xs: "center", md: "right" },
                  }}
                  data-aos="zoom-in-left"
                >
                  <img
                    src={item.image}
                    alt="smallgallery"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Box>
              </Grid>
            </>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
}

export default Smgallary;